import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ButtonGroup, Button, Row, Col, Card, CardBody } from 'reactstrap';
import { Utils } from '../../../../services';
import { Loader, EventTitle } from '../../../../components';
import { loadScreenings } from '../../../../redux';
import ProgressBarScreenings from '../../../Screenings/ScreeningsList/ProgressBarScreenings/ProgressBarScreenings';
import moment from 'moment';
import _ from 'lodash';

import './TodayScreenings.css';

const TodayScreenings = () => {
    const { t, i18n } = useTranslation();
    const dispatch    = useDispatch();

    const { screenings, isLoading, loadingErrorMessage } = useSelector(state => state.screenings);

    useEffect(() => {
        dispatch(loadScreenings({
            stop_at_gte: moment().toISOString(),
            start_at_gte: moment().startOf('day').toISOString(),
            start_at_lte: moment().endOf('day').toISOString(),
        }));
    }, [dispatch])

    const content = React.useMemo(() => {
        return (
            <Row className="flex-1">
                <Col>
                    <div className='h-10 border-bottom'>
                        <h5>{ t('dashboard.todayScreenings.title') }</h5>
                    </div>
                    {isLoading && (
                        <Loader />
                    )}

                    {!isLoading && !loadingErrorMessage && screenings?.length > 0 && (
                        <div className="screenings">
                        {screenings.map(screening => (
                            <div key={ screening._id } className="screening _border">
                                <Link to={`/screenings/edit/${screening._id}`}>
                                    <div className="d-flex items-end gap-2">
                                        {screening.opaque?.posters?.length > 0 && (
                                            <img className="screening-poster" src={ screening.opaque.posters[0].url } />
                                        )}
                                        <div className="flex-1 d-flex flex-column justify-start right-column">
                                            <div className="screening-title w-100">
                                                { Utils.localized_or_fallback(screening.title, i18n.language) }
                                            </div>
                                            <div className="screening-dates w-100">
                                                {moment(screening.start_at).format('llll')}&nbsp;
                                                ({moment(screening.start_at).fromNow()})
                                            </div>
                                            <div className="screening-progression w-100 mt-2">
                                                <ProgressBarScreenings data={screening.buckets} />
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                        </div>
                    )}

                    {!isLoading && !loadingErrorMessage && screenings?.length === 0 && (
                        <h6 className="mt-2 text-italic">
                            { t('dashboard.todayScreenings.no_screening_today') }
                        </h6>
                    )}

                    <div className="text-right">
                        <Button tag={Link} to="/screenings" className="btn btn-info">
                            <i className="fa fa-calendar" />&nbsp;
                            { t('dashboard.todayScreenings.go_to_screenings') }
                        </Button>
                    </div>
                </Col>
            </Row>
        );
    }, [screenings, i18n.language]);

    return (
        <div className='TodayScreenings'>
            { content }
        </div>
    )
}

export default TodayScreenings;
